import axios from '@/api/config';

const role = {
  getRoleById(data) {
    return axios.get(`${process.env.BASE_URL}/role/getRole/` + data, {});
  },
  getRole(data) {
    return axios.get(`${process.env.BASE_URL}/role/getRole`, {params: data});
   },
  getRoleList() {
    return axios.get(`${process.env.BASE_URL}/role/getRoleList`, {});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/role/pageList`, data);
  },
  addRole(data) {
    return axios.post(`${process.env.BASE_URL}/role/addRole`, data);
  },
  updateRole(data) {
    return axios.put(`${process.env.BASE_URL}/role/updateRole`, data);
  },
  deleteRole(data) {console.log(data)
    return axios.delete(`${process.env.BASE_URL}/role/deleteRole`, {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/role/exportExcel`, {params: data});
  },
  importData() {
    return axios.post(`${process.env.BASE_URL}/role/importData`, data);
  }
}

export default role;



// WEBPACK FOOTER //
// ./src/api/role.js